module.exports = __webpack_public_path__ + "static/media/piatto_1.81e20d34.png";